// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","cardContainer":"cardContainer--1O-7r","addSearchCard":"addSearchCard--ib_CM","container":"container--33n72","cardCol":"cardCol--30tbJ"};